export default __webpack_public_path__ + "static/media/offer-vertical-chocolate-lyte@2x.50de0cf4.png";